import * as z from "zod/v4";

export const getGmailThread = {
  name: "getGmailThread" as const,
  input: z.object({ integrationId: z.string(), threadId: z.string() }),
  output: z.record(z.string(), z.unknown()),
};
